module.exports = __webpack_public_path__ + "static/img/Louie-Montgomery.3c7bc64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Louie-Montgomery.jpg
// module id = iYP2
// module chunks = 0